<div class="billing-summary-section">
  <div class="card-heading">
    <div class="section-header">
      <h3 class="section-title">Billing Forecast</h3>
    </div>
    <p class="card-description">
      Projected Billable Hours based on recent monthly activity.
    </p>
  </div>

  @if (isLoading) {
    <div class="loading-state">
      <mat-spinner diameter="28"></mat-spinner>
    </div>
  } @else {
    <div class="summary-stats">
      <div class="stat-item">
        <span class="stat-value">{{ formatHours(monthlyAverageBilledHours) }}</span>
        <span class="stat-label">
          Average of the actual hours over the last six months.
        </span>
      </div>
      <div class="stat-item">
        <span class="stat-value">{{
          formatHours(currentYearToDateBilledHours)
        }}</span>
        <span class="stat-label">
          Total billable hours recorded for the current year, to-date.
        </span>
      </div>
      <div class="stat-item">
        <span class="stat-value">{{
          formatHours(forecastedBilledHoursThisYear)
        }}</span>
        <span class="stat-label">
          Total hours forecasted to year end from the actuals + the average per
          month.
        </span>
      </div>
      <div class="stat-item">
        <span class="stat-value">{{
          formatHours(forecasted12MonthBilledHours)
        }}</span>
        <span class="stat-label">
          Total hours forecasted for the next 12 months from monthly average.
        </span>
      </div>
      @if (hasChart) {
        <div class="stat-separator" aria-hidden="true"></div>
        <div
          class="mode-selector"
          [class.mode-selector--end]="chartMode === 'cumulative'"
        >
          <span class="mode-selector__thumb" aria-hidden="true"></span>
          <button
            type="button"
            class="mode-card"
            [class.active]="chartMode === 'exact'"
            [attr.aria-pressed]="chartMode === 'exact'"
            (click)="setChartMode('exact')"
          >
            <mat-icon class="mode-card__icon">bar_chart</mat-icon>
            <span class="mode-card__text">
              <span class="mode-card__title">Per Month</span>
              <span class="mode-card__sub">Hours each month</span>
            </span>
          </button>
          <button
            type="button"
            class="mode-card"
            [class.active]="chartMode === 'cumulative'"
            [attr.aria-pressed]="chartMode === 'cumulative'"
            (click)="setChartMode('cumulative')"
          >
            <mat-icon class="mode-card__icon">stacked_line_chart</mat-icon>
            <span class="mode-card__text">
              <span class="mode-card__title">Cumulative</span>
              <span class="mode-card__sub">Running total</span>
            </span>
          </button>
        </div>
      }
    </div>

    @if (hasChart) {
      <div class="chart-container">
        <canvas
          baseChart
          [type]="chartType"
          [data]="chartData"
          [options]="chartOptions"
        ></canvas>
      </div>
    }
  }
</div>
